import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AvatarViewComponent } from "./avatar-view/avatar-view.component";

const IMPORT = [CommonModule, TooltipModule];

const DECLARATION = [AvatarViewComponent];

@NgModule({
  imports: [...IMPORT],
  declarations: [...DECLARATION],
  exports: [...IMPORT, ...DECLARATION]
})
export class AvatarViewModule {}
